export default __webpack_public_path__ + "static/media/463.3105ae35.gif";